import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch, useStore } from 'react-redux'
import PageContainer from '../fragments/page-container'
import {
	action_add_search_list,
	action_fetch_search_list,
	action_fetch_search_sorters,
	action_fetch_search_filter
} from '../../../../store/actions/pages/search'
import List from '../components/list'
import { filterItemsToString, getFilterItemsFromQuery } from '../utils'
import queryString from 'query-string'
import Empty from '../components/list/empty'
import { useLocation } from 'react-router-dom'
import { useSensors } from '../../../hooks/sensor'
import { generateFilter } from '../../../utils/sensor'
import FacebookEvents from '../../../ads/events/facebook'
import BottomBannerTip from '../../details/module/bottom-banner'

const getValidFilterItems = items => {
	const newItems = []

	items?.forEach(item => {
		if (['color', 'size', 'tags', 'category'].indexOf(item.fieldName) >= 0 || item.fieldName?.indexOf('tags-') === 0) {
			newItems.push(item)
		}
	})
	return newItems
}

const decodeCode = str => {
	let decoded = str
	try {
		decoded = decodeURIComponent(str)
	} catch (e) { }
	return decoded
}

const parseSearch = search => {
	const parsed = queryString.parse(search)
	if (parsed && parsed.sort_by) {
		parsed.parentSkus = parsed.sort_by
	}
	return parsed
}

const parseParams = search => {
	if (!search) return
	let newParams = {}
	Object.keys(search).forEach(key => {
		if (search[key] instanceof Array) {
			newParams[key] = search[key]?.filter((value, index, s) => s.indexOf(value) === index).join?.(',')
		} else {
			newParams[key] = search[key]
		}
	})

	if (search?.sort_by) {
		newParams['parentSkus'] = search.sort_by
	}

	if (search?.key) {
		newParams['searchValue'] = search?.key
	}

	return newParams
}

const Search = props => {
	const dispatch = useDispatch()
	const pageSearch = useSelector((state) => state.pageSearch)
	const store = useStore()
	const { params } = props.match
	const location = useLocation()
	const search = parseSearch(location.search)
	const [sensors, setSensors] = useState(useSensors())
	const filterStr = generateFilter(pageSearch?.filterData, pageSearch?.sorters)

	if (search?.searchValue) {
		search.searchValue = decodeCode(search?.searchValue)
	}

	if (search?.key) {
		search.key = decodeCode(search?.key)
	}


	const filterItems = getFilterItemsFromQuery(search)
	const [value, setValue] = useState(filterItems)
	const [sorter, setSorter] = useState(Number(search['sort']) || 0)
	const [tag, setTag] = useState({
		fieldName: 'tags',
		selections: (search?.tags instanceof Array) ? (search.tags.join(',').split(',').map(s => ({ value: s }))) : (search.tags?.split(',').map(s => ({ value: s })))
	})

	const [min, setMin] = useState(search.minPrice && !isNaN(search.minPrice) ? Number(search.minPrice) : undefined)
	const [max, setMax] = useState(search.maxPrice && !isNaN(search.maxPrice) ? Number(search.maxPrice) : undefined)


	useEffect(async () => {
		if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {
			await Search.fetchData(store, params, search, {})

			window.scrollTo({
				top: 0,
			})

		}
	}, [params.id, location.search])

	useEffect(() =>{
		if (window.GeekoSensors) {
            window.GeekoSensors.Track('SearchResult', {
                resource_content: search?.searchValue || search?.key,
                product_count: pageSearch?.total
            })
        }
		FacebookEvents.search({search_string: search?.searchValue || search?.key})
	}, []);



	const initPage = async () => {

	}


	const submitHandle = filterItems => {
		let resultSearch




		if (tag && tag.filterItems && tag.filterItems.length > 0) {
			if (filterItems?.some(f => f.fieldName === 'tags')) {
				resultSearch = filterItemsToString(filterItems)
			} else {
				if (tag.value) {
					resultSearch = filterItemsToString([...filterItems, { fieldName: 'tags', selections: [tag] }])
				} else {
					resultSearch = filterItemsToString([...filterItems])
				}
			}
		} else {
			resultSearch = filterItemsToString(filterItems)
		}

		if (resultSearch?.indexOf('key=') < 0 && resultSearch?.indexOf('searchValue=') < 0) {
			if (search?.searchValue) {
				resultSearch = `searchValue=${search?.searchValue}&${resultSearch}`
			} else if (search?.key) {
				resultSearch = `key=${search?.key}&${resultSearch}`
			}
		}
		setValue(filterItems)
		props.history.replace(`${location.pathname}?${resultSearch}`)
	}

	const handleSorter = sorter => {
		setSorter(sorter)
		props.history.replace(`${location.pathname}?${queryString.stringify({ ...search, sort: sorter })}`)
	}

	const handleTag = tag => {
		setTag(tag)
		const tagSearch = { ...search, tags: tag?.value }
		props.history.replace(`${location.pathname}?${queryString.stringify(tagSearch)}`)
	}

	const onScroll = () => {
		const initialFilterItems = getFilterItemsFromQuery(search)
		const { sorters } = pageSearch

		const requestSorter = (sorters instanceof Array) ? sorters?.[sorter]?.value : sorter
		const filter = {
			sorter: requestSorter,
			filterItems: getValidFilterItems(initialFilterItems),
		}

		const params = search?.key ? { ...search, searchValue: search.key } : search

		dispatch(action_add_search_list(filter, { ...params, skip: pageSearch?.skip }, {}))
	}


	return <div>
		<PageContainer links={[
			{
				href: '#',
				title: decodeCode(search?.searchValue || search?.key)
			}
		]}
			filterVo={pageSearch?.filterVo}
			sorters={pageSearch?.sorters}
			onSubmit={submitHandle}
			value={value}
			sorter={sorter}
			onSorter={handleSorter}
			onTag={handleTag}
			tag={tag}
		>
			{
				pageSearch?.finished && (!pageSearch?.list || pageSearch?.list?.length < 1) ? <Empty /> : <List filter={filterStr} sensors={sensors} products={pageSearch.list} request={onScroll} loading={pageSearch?.loading} finished={pageSearch?.finished} />
			}
		</PageContainer>

		<BottomBannerTip isFixed />
	</div>
}




Search.fetchData = async (store, params, search, headers) => {

	const initialFilterItems = getFilterItemsFromQuery(search)
	const sort = search.sort || 0
	const sorters = await store.dispatch(action_fetch_search_sorters({}, headers))
	const sorter = (sorters instanceof Array) ? sorters?.[sort]?.value : sort
	const searchValue = search?.searchValue || search?.key

	const filter = {
		sorter: sorter,
		filterItems: getValidFilterItems(initialFilterItems),
	}

	const values = await Promise.all([
		store.dispatch(action_fetch_search_list(filter, parseParams(search), headers)),
		store.dispatch(action_fetch_search_filter({ searchValue }, headers)),
	])
	return [...values, sorters]
}

export default Search
